'use strict';

module.exports = /* @ngInject */ function () {
    return {
		restrict: 'E',
		scope: {},
		templateUrl: `./${BUILD_PATH}/mobile-sidenav.directive.html`,
		controller: /* @ngInject */ function ($scope, $window, $mdSidenav, $mdComponentRegistry, headerService) {

			$scope.SECTION_TYPES = headerService.SECTION_TYPES;

			$scope.sideNavId = headerService.mobileNavId;
			$scope.logo = '';
			$scope.headerText = '';
			$scope.section = '';
			$scope.navigationItems = [];

			$scope.navigate = navigate;

			init();

			function init() {
				registerListeners();
				getData();
			}

			function registerListeners() {
				$mdComponentRegistry.when($scope.sideNavId).then(() => {
					$scope.logo = headerService.getLogo();
					const intervalText = setInterval(() => {
						$scope.headerText = headerService.getHeaderText();
						if($scope.headerText){
							clearInterval(intervalText);
						}
					}, 100);
					const intervalSection = setInterval(() => {
						$scope.section = headerService.getSection();
						if($scope.section){
							clearInterval(intervalSection);
						}
					}, 100);
				});
			}

			function getData(){
				headerService.getNavigationItems.query().$promise.then((data) => {
					$scope.navigationItems = data;
				})
			}

			function navigate(navigationItem){
				const navigateTo = headerService.getModuleNavigation(navigationItem.module);
				if(navigateTo){
					window.openContent(navigateTo, navigationItem.title, () => {
						headerService.toggleSidenav();
					});
				}
			}

		}
	};
}
